var selectvalue = [
  {optValue: 'US', optText: 'United States (USD &dollar;)', spritePosition:'0px -126px', modalMessage:"<span class='h3'>Mattel Creations ships to United States</span><div class='recommendation-modal__benefits'><ul><li>Product prices are shown in &dollar;</li><li>Product prices include duties and taxes to reflect true total product costs</li><li>Shipping fees have been upgraded, now only &dollar;9 for standard shipping</li></ul></div><p class='thanku-text'>Thank you for shopping Mattel Creations!</p>", shopNowtext:"Shop Now", changeCountry:"Change Shipping country", countryModalmsg:"Change Shipping country", countryModalcontinue:"Continue", countryModalcancel:"Cancel"},
  {optValue: 'AU', optText: 'Australia (AUD &dollar;)', spritePosition:'0px -288px', modalMessage:"<span class='h3'>Mattel Creations ships to Australia</span><div class='recommendation-modal__benefits'><ul><li>Product prices are shown in AUD</li><li>Product prices include duties and taxes to reflect true total product costs</li><li>Shipping fees have been upgraded, now only AUD 15 for standard shipping</li></ul></div><p class='thanku-text'>Thank you for shopping Mattel Creations!</p>", shopNowtext:"Shop Now", changeCountry:"Change Shipping country", countryModalmsg:"CHANGE SHIPPING COUNTRY", countryModalcontinue:"Continue", countryModalcancel:"Cancel"},
  {optValue: 'AT', optText: 'Austria', spritePosition:'0px -180px', modalMessage:"<span class='h3'>Mattel Creations ships to Austria</span><div class='recommendation-modal__benefits'><ul><li>Product prices are shown in &dollar;</li><li>Product prices include duties and taxes to reflect true total product costs</li><li>Shipping fees have been upgraded, now only &dollar;9 for standard shipping</li></ul></div><p class='thanku-text'>Thank you for shopping Mattel Creations!</p>"},
  {optValue: 'BE', optText: 'Belgium', spritePosition:'0px -198px', modalMessage:"<span class='h3'>Mattel Creations ships to Belgium</span><div class='recommendation-modal__benefits'><ul><li>Product prices are shown in &dollar;</li><li>Product prices include duties and taxes to reflect true total product costs</li><li>Shipping fees have been upgraded, now only &dollar;9 for standard shipping</li></ul></div><p class='thanku-text'>Thank you for shopping Mattel Creations!</p>"},
  {optValue: 'CA', optText: 'Canada (CAD &dollar;)', spritePosition:'0px 0px', modalMessage:"<span class='h3'>Mattel Creations ships to Canada</span><div class='recommendation-modal__benefits'><ul><li>Product prices are shown in &dollar; CAD</li><li>Product prices include duties where applicable to reflect true total product costs</li><li>No additional duties on toys at checkout.</li><li>Shipping fees have been upgraded, now only $13 CAD for standard shipping</li></ul></div><p class='thanku-text'>Thank you for shopping Mattel Creations!</p>", shopNowtext:"Shop Now", changeCountry:"Change Shipping country", countryModalmsg:"CHANGE SHIPPING COUNTRY", countryModalcontinue:"Continue", countryModalcancel:"Cancel"},
  {optValue: 'CZ', optText: 'Czech Republic', spritePosition:'0px -234px', modalMessage:"<span class='h3'>Mattel Creations ships to Czech Republic</span><div class='recommendation-modal__benefits'><ul><li>Product prices are shown in &dollar;</li><li>Product prices include duties and taxes to reflect true total product costs</li><li>Shipping fees have been upgraded, now only &dollar;9 for standard shipping</li></ul></div><p class='thanku-text'>Thank you for shopping Mattel Creations!</p>"},
  {optValue: 'FR', optText: 'France (EUR &euro;)', spritePosition:'0px -18px', modalMessage:"<span class='h3'>MATTEL CREATIONS LIVRE EN FRANCE</span><div class='recommendation-modal__benefits'><ul><li>Les prix sont indiqués en €</li><li>Les prix tiennent en compte des frais de douanes et de la t.v.a française en vigueur</li><li>Les frais de livraison ont été mis à jour, les frais standards ne sont plus qu’à 10€</li></ul></div><p class='thanku-text'>Merci d’avoir acheté sur Mattel Creations!</p>", shopNowtext:"Acheter Maintenant", changeCountry:"Changer Pays de Livraison", countryModalmsg:"CHANGER PAYS DE LIVRAISON", countryModalcontinue:"Continuer", countryModalcancel:"Annuler"},
  {optValue: 'DE', optText: 'Germany (EUR &euro;)', spritePosition:'0px -36px', modalMessage:"<span class='h3'>MATTEL CREATIONS LIEFERT NACH DEUTSCHLAND</span><div class='recommendation-modal__benefits'><ul><li>Die Produktpreise sind in € angegeben</li><li>Die Produktpreise enthalten Zölle und Steuern, um die tatsächlichen Gesamtkosten des Produkts widerzuspiegeln</li><li>Die Versandgebühren wurden geupdatet, jetzt nur noch 10€ für den Standardversand</li></ul></div><p class='thanku-text'>Vielen Dank für Ihren Einkauf bei Mattel Creations!</p>", shopNowtext:"Jetzt einkaufen", changeCountry:"Versandland ändern", countryModalmsg:"VERSANDLAND ÄNDERN", countryModalcontinue:"Weiter", countryModalcancel:"Absagen"},
  {optValue: 'HU', optText: 'Hungary', spritePosition:'0px -252px', modalMessage:"<span class='h3'>Mattel Creations ships to Hungary</span><div class='recommendation-modal__benefits'><ul><li>Product prices are shown in &dollar;</li><li>Product prices include duties and taxes to reflect true total product costs</li><li>Shipping fees have been upgraded, now only &dollar;9 for standard shipping</li></ul></div><p class='thanku-text'>Thank you for shopping Mattel Creations!</p>"},
  {optValue: 'IT', optText: 'Italy (EUR &euro;)', spritePosition:'0px -54px', modalMessage:"<span class='h3'>MATTEL CREATIONS SPEDISCE IN ITALIA</span><div class='recommendation-modal__benefits'><ul><li>I prezzi dei prodotti sono in &euro;</li><li>I prezzi dei prodotti includono tasse e imposte riflettendo già il vero costo totale</li><li>Le spese di spedizione sono state aggiornate: ora la spedizione standard costa solo 10&euro;</li></ul></div><p class='thanku-text'>Grazie per i tuoi acquisti Mattel Creations!</p>", shopNowtext:"Acquista Ora", changeCountry:"Cambia Paese di Spedizione", countryModalmsg:"CAMBIA PAESE DI SPEDIZIONE", countryModalcontinue:"Continua", countryModalcancel:"Annulla"},
  {optValue: 'JP', optText: 'Japan (JPY &yen;)', spritePosition:'0px -90px', modalMessage:"<span class='h3'>マテルクリエーション 日本へ発送について</span><div class='recommendation-modal__benefits'><ul><li>商品価格は円表示となっております</li><li>送料改定がございました。現在は通常配送にて&yen;1,400となります</li></ul></div><p class='thanku-text'>マテルクリエーションにてお買上頂きまして誠にありがとうございます！</p>", shopNowtext:"今すぐ購入", changeCountry:"配送先国を変更する", countryModalmsg:"配送先国を変更する", countryModalcontinue:"続ける", countryModalcancel:"キャンセル"},
  {optValue: 'MX', optText: 'Mexico (MXN &#8369;)', spritePosition:'0px -162px', modalMessage:"<span class='h3'>MATTEL CREATIONS ENVÍA A MÉXICO</span><div class='recommendation-modal__benefits'><ul><li>Los precios se muestran en pesos mexicanos (MXN)</li><li>Los precios de los productos incluyen tasas de importación e impuestos para reflejar los costos totales reales del producto.</li><li>Las tarifas de envío se han actualizado, ahora el costo del envío estándar es de MXN$200</li></ul></div><p class='thanku-text'>¡Gracias por comprar en Mattel Creations!</p>", shopNowtext:"Comprar Ahora", changeCountry:"Cambiar País de Envío", countryModalmsg:"Cambiar País de Envío", countryModalcontinue:"Continuar", countryModalcancel:"Cancelar"},
  {optValue: 'NL', optText: 'Netherlands', spritePosition:'0px -270px', modalMessage:"<span class='h3'>Mattel Creations ships to Netherlands</span><div class='recommendation-modal__benefits'><ul><li>Product prices are shown in &dollar;</li><li>Product prices include duties and taxes to reflect true total product costs</li><li>Shipping fees have been upgraded, now only &dollar;9 for standard shipping</li></ul></div><p class='thanku-text'>Thank you for shopping Mattel Creations!</p>"},
  {optValue: 'NZ', optText: 'New Zealand', spritePosition:'0px -288px', modalMessage:"<span class='h3'>Mattel Creations ships to New Zealand</span><div class='recommendation-modal__benefits'><ul><li>Product prices are shown in &dollar;</li><li>Product prices include duties and taxes to reflect true total product costs</li><li>Shipping fees have been upgraded, now only &dollar;9 for standard shipping</li></ul></div><p class='thanku-text'>Thank you for shopping Mattel Creations!</p>"},
  {optValue: 'PL', optText: 'Poland', spritePosition:'0px -306px', modalMessage:"<span class='h3'>Mattel Creations ships to Poland</span><div class='recommendation-modal__benefits'><ul><li>Product prices are shown in &dollar;</li><li>Product prices include duties and taxes to reflect true total product costs</li><li>Shipping fees have been upgraded, now only &dollar;9 for standard shipping</li></ul></div><p class='thanku-text'>Thank you for shopping Mattel Creations!</p>"},
  {optValue: 'PT', optText: 'Portugal', spritePosition:'0px -324px', modalMessage:"<span class='h3'>Mattel Creations ships to Portugal</span><div class='recommendation-modal__benefits'><ul><li>Product prices are shown in &dollar;</li><li>Product prices include duties and taxes to reflect true total product costs</li><li>Shipping fees have been upgraded, now only &dollar;9 for standard shipping</li></ul></div><p class='thanku-text'>Thank you for shopping Mattel Creations!</p>"},
  {optValue: 'SG', optText: 'Singapore', spritePosition:'0px -342px', modalMessage:"<span class='h3'>Mattel Creations ships to Singapore</span><div class='recommendation-modal__benefits'><ul><li>Product prices are shown in &dollar;</li><li>Product prices include duties and taxes to reflect true total product costs</li><li>Shipping fees have been upgraded, now only &dollar;9 for standard shipping</li></ul></div><p class='thanku-text'>Thank you for shopping Mattel Creations!</p>"},
  {optValue: 'ES', optText: 'Spain (EUR &euro;)', spritePosition:'0px -72px', modalMessage:"<span class='h3'>MATTEL CREATIONS HACE ENVÍOS A ESPAÑA</span><div class='recommendation-modal__benefits'><ul><li>Precio del producto mostrado en &euro;</li><li>El precio del producto lleva incluido tasas e impuestos para reflejar el costo total real del producto</li><li>Los gastos de envío han sido actualizados, ahora solo por &euro;10 el envío estándar </li></ul></div><p class='thanku-text'>Gracias por comprar Mattel Creations!</p>", shopNowtext:"Compra ahora", changeCountry:"Modifica Dirección de Envío", countryModalmsg:"MODIFICA DIRECCIÓN DE ENVÍO", countryModalcontinue:"Continuar", countryModalcancel:"Cancelar"},
  {optValue: 'CH', optText: 'Switzerland', spritePosition:'0px -360px', modalMessage:"<span class='h3'>Mattel Creations ships to Switzerland</span><div class='recommendation-modal__benefits'><ul><li>Product prices are shown in &dollar;</li><li>Product prices include duties and taxes to reflect true total product costs</li><li>Shipping fees have been upgraded, now only &dollar;9 for standard shipping</li></ul></div><p class='thanku-text'>Thank you for shopping Mattel Creations!</p>"},
  {optValue: 'GB', optText: 'United Kingdom (GBP &pound;)', spritePosition:'0px -108px', modalMessage:"<span class='h3'>Mattel Creations ships to United Kingdom</span><div class='recommendation-modal__benefits'><ul><li>Product prices are shown in &pound;</li><li>Product prices include duties and taxes to reflect true total product costs</li><li>Shipping fees have been upgraded, now only &pound;9 for standard shipping</li></ul></div><p class='thanku-text'>Thank you for shopping Mattel Creations!</p>", shopNowtext:"Shop Now", changeCountry:"Change Shipping country", countryModalmsg:"Change Shipping country", countryModalcontinue:"Continue", countryModalcancel:"Cancel"}
];

function preorderDateShow() {
    let orederP = $(".template-customers-order");
    let dateA = [];
    if(orederP.length>0){
      let orderID = $(".orderID").val();
      $.ajax({
          url:	"/search?q="+orderID+"&view=customer-orders.json",
          type:	'GET'
      }).done(function(data){
          let dateOrder = JSON.parse(data);
          dateOrder = dateOrder.date;
          for(var i=0;i<dateOrder.length;i++){
              let dateO = dateOrder[i];
              if(dateO.indexOf('{')<0){
                  dateO = '{'+dateO;
              }
              if(dateO.indexOf('}')<0){
                  dateO = dateO+'}';
              }
              dateO = JSON.parse(dateO);
              dateA.push(dateO);
          }
          orederP.find('.order-item').each(function(index){
            var thisE = $(this);
            var itemKey = thisE.attr('item-key');
            itemKey = parseInt(itemKey);
            var itemSku = thisE.attr('oder-sku');
            $.ajax({
            url:	"/search?q="+itemSku+"&view=all-products.json",
            type:	'GET'
          }).done(function(data) {
        if ( data.trim().length != 0 ) {
          let preStatus = JSON.parse(data);
          if(preStatus == true){
          for(var j=0;j<dateA.length;j++){
            var dateTr = dateA[j][itemKey];
            if(dateTr){
            if(dateTr.indexOf('T') > 0){
              dateTr = dateTr.split('T')[0];
            }
            var monthA = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
            dateTr = new Date(dateTr);
            var utcDate = dateTr.getUTCDate();
            var utcMonth = dateTr.getUTCMonth();
            utcMonth = monthA[utcMonth];
            var utcYear = dateTr.getUTCFullYear();
            dateTr = utcMonth+" "+utcDate+", "+utcYear;
                        thisE.find('.backOrederDateP').html(dateTr);
                        thisE.find('.backOrderDateClass').removeClass('hide');

            }

          }
          }
        }
          })

          });
      });
    }

}
function preorderTextShow() {

  let accountP = $(".template-customers-account");
  if(accountP.length>0){
    if(accountP.length>0){
    var oderList = accountP.find('.order-list');
  }
  if(oderList.length>0){
    oderList.each(function(){
      let thisE = $(this);
      let skuO = thisE.attr('oder-sku');
      let oderUrl = thisE.attr('order-url');
      $.ajax({
        url:	"/search?q="+skuO+"&view=all-products.json",
        type:	'GET'
      })
      .done(function(data) {
          let preStatus = JSON.parse(data);
          if(preStatus == true){
            if(accountP.length>0){
              thisE.find('.oder-status .status-text').html('<a href='+oderUrl+' style="text-decoration: underline">See Preorder Date</a>');
              thisE.find('.oder-status .status-text').removeClass('hide');
            }
          }
          else{
            if(accountP.length>0){
              thisE.find('.oder-status .status-text').removeClass('hide');
            }
          }
          thisE.find('.oder-status .skeleton-load').addClass('hide');
      })
    })
  }
  }

}
function dropdownValue() {
  var getvalue = setInterval(function() {
    var selectWrap = $(".locale-selectors__content .locale-selectors__selector");
    if(selectWrap.length > 0){
      makedorpdown(SDG.Data.locale,selectvalue);
      clearInterval(getvalue);
    }
  }, 100);
}
function makedorpdown(selectedcode,data){
    var dropC = '';
    var constructedLocale;
    if (selectedcode === '/') {
      constructedLocale = 'US';
    } else {
      constructedLocale = selectedcode.split('-')[1].toUpperCase();
    }

    for(var i=0;i<data.length;i++){
      if(data[i].optValue == constructedLocale){
        dropC += '<button class="select_btn"><img class="selectedflag" style="object-position:'+ data[i].spritePosition +'" src="https://cdn.shopify.com/s/files/1/0561/4790/2654/files/flag-updated-02-29-24.png" alt="Selected Flag Icon" />'+data[i].optText.split('(')[0]+'</button>';
    }
  }
  dropC += '<div class="js-country-selector select_content hide">';
  dropC += '<ul>';
  for(var i=0;i<=data.length;i++){
    if(typeof data[i] != 'undefined'){
      dropC += '<li>'
      dropC += '<img class="flag'+i+'" style="object-position:'+ data[i].spritePosition +'" src="https://cdn.shopify.com/s/files/1/0561/4790/2654/files/flag-updated-02-29-24.png" alt="'+data[i].optValue+' Flag Icon" /><a href="javascript:void(0)" data-value="'+data[i].optValue+'">'+data[i].optText.split('(')[0]+'</a>';
      dropC += '</li>';
    }
  }
  dropC += '</ul>';
  dropC += '</div>';
  $(".currency__changer_wrap .changer_content").html(dropC);
}

$(document).on('click','.currency__changer_wrap .select_content li', function(e) {
  let clickedV = $(this).find('a').attr('data-value');
  let localWrap = $(".locale-selectors__container");
  if(clickedV == "rest"){
    clickedV = "US";
  }

  // Update return_to input value
  var returnToInput = $('.locale-selectors__content input[name="return_to"]');
  var localeLinks = $('link[rel="alternate"]');
  var hreflang = '';
  localeLinks.each(function() {
    var hreflangValue = $(this).attr('hreflang');
    var country = hreflangValue?.split('-')?.[1];

    if (country && country.toUpperCase() === clickedV.toUpperCase()) {
      hreflang = hreflangValue;
      return false;
    }
  });

  if (hreflang) {
    var modifiedUrl = window.location.pathname.replace(/\/[a-z]{2}-[a-z]{2}(?=\/|$)|\/(?=\/|$)/, "/" + hreflang);
    returnToInput.val(modifiedUrl);
  }

  localWrap.find('.locale-selectors__selector').val(clickedV).change();
  localWrap.find('form').submit();
});
$(document).on('click','.currency__changer_wrap .select_btn', function(e) {
  $('.currency__changer_wrap .select_btn').next().toggleClass("hide");
  $('.currency__changer_wrap .select_btn').toggleClass("open");

});
$(document).on('click','.currency__changer_wrap .select_content', function(e) {
  setCookie('globalemodalClose','false');
});
$(document).click(function(event) {
    var container = $(".currency__changer_wrap .select_btn");
    if (!container.is(event.target) && !container.has(event.target).length) {
        if($('.currency__changer_wrap .select_btn').hasClass("open")){
          $('.currency__changer_wrap .select_btn').toggleClass("open");
          $('.currency__changer_wrap .select_btn').next().addClass("hide");
        }
    }
});

$(document).on('click','.newsletter-modal-wrap', function(e) {
    if(screen.width > 767){
      if ($(e.target).closest(".modal-container").length === 0) {
        $("#dropdown-cart").hide();
        $(".newsletter-modal-wrap").addClass('hide ')
      }

    }
  });

function emailvalidation(email){
    var pattern = new RegExp(/^([a-zA-Z]+[a-zA-Z0-9_\-\+\.]+)@((([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/);
    return pattern.test(email);
}
// newsletter section submit event
$(document).on('click', '.newsletter-box .input-field-submit', function(e){
    e.preventDefault();
    var thisE = $(this);
    var targetId = thisE.parents(".custom-email-signup").attr("id");
    if(typeof targetId === 'undefined'){
        var targetId = thisE.parents(".shopify-section").attr("id");
    }
    var ddParent = thisE.parents(".email-signup-wrap").parent();
    var parent = thisE.parents('.newsletter-box');
    var parentEmail = thisE.parents(".email-signup-content");
    var parentContainer = thisE.parents(".email-signup-container");
    if(parent.find('.input-field-text').length > 0){
        var emailV = parent.find('.input-field-text').val();
    }
    else{
        var emailV = parent.find('.simple-newsletter').val();
    }
    var emailErrorDiv = parent.find('.error-wrap');
    var errorMsg = emailErrorDiv.attr('data-value');
    var errorHtml = "<p class='error-text'>"+errorMsg+"</p>";
    var parentsDD = thisE.parents('.email-signup-wrap').parent();
    var termsP = parentEmail.find('.checkbox-con');
    var termsC = false;
    if(termsP.length > 0){
        if(termsP.find('input[type="checkbox"]').prop('checked') == true){
            termsC = true
        }
    }
    else{
        termsC = true
    }

    if(termsC == true){
        if(emailV != ''){
            var resE = emailvalidation(emailV); // emailValidation is defined in this file
            if(resE){
                sessionStorage.setItem("targetId",targetId);
                if (parentContainer.hasClass("footer") == true) {
                  gtagformSubmit_email("footer","Emailsignup");
                } else {
                  gtagformSubmit_emailstandalone("content_area","Emailsignup");
                }

                // sets sessionStorage value for use on page reload
                var source = parent.parents('.email-signup-wrap').attr('data-src');
                var makeT = 'email_mc_'+source;
                var ftags = 'prospect,newsletter,'+makeT;
                parent.find('.input-field-wrap input[name="contact[tags]"]').val(ftags);
                parent.find('form').submit();
                var newsletterSectionId = parent.attr('data-tarID');
                sessionStorage.setItem("newsletterSectionId", newsletterSectionId);

                // This block is dependant on enabling option theme settings
                // If theme settings are enabled popup will display before submit
                if(parent.find('.input-field-text').length > 0){
                    ddParent.find("#prefilledEmail").val(emailV);
                    openmodal(parentsDD);
                    newsletterLogoshowLimit(ddParent);
                }
            }
            else{
                // error handling if email is invalid i.e missing @
                emailErrorDiv.html(errorHtml);
                parentContainer.hasClass("footer") == true ? gtagformError_email("Email Address","The email entered is not in a valid format!") : gtagformError_emailstandalone("Email Address","The email entered is not in a valid format!");
                setTimeout(function(){
                    emailErrorDiv.html('');
                },2000);
            }
        }
        else{
            // error handling if email is emptys
            emailErrorDiv.html(errorHtml);
            parentContainer.hasClass("footer") == true ? gtagformError_email("Email Address","The email address field cannot be empty!") : gtagformError_emailstandalone("Email Address","The email address field cannot be empty!");
            setTimeout(function(){
                emailErrorDiv.html('');
            },2000);
        }
    }
    else{
        // error handling if terms and conditions checkbox is not ticked
        termsP.find('label').addClass('error');
        parentContainer.hasClass("footer") == true ? gtagformError_email("Terms and condition","Please check the terms and condition checkbox!") : gtagformError_emailstandalone("Terms and condition","Please check the terms and condition checkbox!");
        setTimeout( function(){
            termsP.find('label').removeClass('error');
        } ,1800);
    }

});


function newsletterLogoshowLimit(modalwrap){
    var logowrap = modalwrap.find('.logo-wrapper');
    var logoLimit = logowrap.find('.logo-container').attr('data-limit');
    logoLimit = parseInt(logoLimit);
    logowrap.find('.brand-logo-li').each(function(index ){
        var cthis = $(this);
        var countD = cthis.attr('data-count');
        countD = parseInt(countD);
        if(index  < logoLimit){
            cthis.removeClass('hide');
        }
        else{
            cthis.removeClass('brand-logo-li');
        }
    });

};
function checkboxActive(data){
    var parentD = data.parents('.newsletter-modal-wrap.form');
    function innerF(){
        var activeCount = parentD.find(".brand-logo-li input:checked").length;
        if(dataLimit > activeCount){
            parentD.find(".logo-container #selectall-check").prop('checked', false)
        }
        else{
            parentD.find(".logo-container #selectall-check").prop('checked', true)
        }
    }
    var dataLimit = parentD.find(".logo-container").attr('data-limit');
    dataLimit = parseInt(dataLimit);
    var thisE = data.find('.brand-name');
    var brandV = thisE.val();
    if(thisE.prop("checked") == true) {
        if(brandV == 'selectall-check'){
            parentD.find(".brand-name").prop('checked', false);
        }
        else{
            thisE.prop('checked', false);
            innerF();

        }
    }
    else{
        if(brandV == 'selectall-check'){
            parentD.find(".brand-name").prop('checked', true);
        }
        else{
            thisE.prop('checked', true);
            innerF();
        }
    }




}


function imagecarousel(){

    var wrap = $(".image-carousel-wrap");
    var sliderDiv = wrap.find('.slider-image-carousel');

    if (typeof sliderDiv.slick !== 'function') return;

    sliderDiv.slick({
        arrows: true,
        dots: true,
        prevArrow: '<button class="pre-btn arrows-slick"></button>',
        nextArrow: '<button class="next-btn arrows-slick"></button>',
    }).on('afterChange', function(){
        slickFindColor(sliderDiv);
    });
}

function slickFindColor(data){
    var wrap = data;
    if(wrap.hasClass('slick-initialized slick-slider')){
        var dotBorderColor = wrap.attr('data-dotbc');
        var dotActiveBorderColor = wrap.attr('data-dotabc');
        var dotActiveBGColor = wrap.attr('data-dotabg');
        wrap.find('.slick-dots li button').css({'border': '1px solid transparent'+'', 'background-color': 'transparent'});
        wrap.find('.slick-dots li button').css({'border': '1px solid'+dotBorderColor});
        if(wrap.find('.slick-dots li').hasClass('slick-active')){
            wrap.find('.slick-dots li.slick-active button').css({'border': '1px solid'+dotActiveBorderColor+'', 'background-color': dotActiveBGColor})
        }
    }
}


function alreadySubcribed(){
    var currentPage = $("#pageIndentify").val();
    var errorMsgM = 'Already Subscribed.';
    var errorHtml = "<p class='error-text'>"+errorMsgM+"</p>";
    var sessVal = sessionStorage.getItem('newsletterSectionId');
    if(currentPage == 'product'){

        if(sessVal == 'tar-soldOutSec'){
            var parentsM = $("#"+sessVal).parent();
            var emailErrorDiv = parentsM.find('#signupError');
        }
        else{
            var parentsM = $(".email-signup-wrap[data-mainid="+sessVal+"]");
            var emailErrorDiv = parentsM.find('.error-wrap');
        }

    }
    else{
            var parentsM = $(".email-signup-wrap[data-mainid="+sessVal+"]");
            var emailErrorDiv = parentsM.find('.error-wrap');

    }

    emailErrorDiv.html(errorHtml);
    $('html, body').animate({ scrollTop: parentsM.offset().top }, 'slow');
}

// displays thank you modal after user submits newsletter form
// dependant on sessionStorage values
function challengePageNews(){
  var sectionIDK = sessionStorage.getItem("newsletterSectionId");
  var targetId = sessionStorage.getItem("targetId");
  var currentUrl = location.href;
  if (sectionIDK) {
    var Vs = $(".newsletter-modal-wrap.thankyou.hide").attr('id');
    $(".newsletter-modal-wrap.thankyou").each(function(index ){
      var id = $(this).attr('id');
        if(id == sectionIDK){
          $(this).removeClass('hide');
        }
        if(targetId){
          $('html, body').animate({
            scrollTop: $("#"+targetId).offset().top
          }, 2000);
        }
    });
  }
}


// function coundtryCheck(){
//     $.getJSON("https://ipinfo.io", function(response) {
//         var cntry = response.country;
//         if(cntry == 'US'){
//             $(".newsletter-modal-wrap.form .logo-container li input[type='checkbox']").prop('checked', true);
//         }
//     }, "jsonp");
// }

function coundtryCheck(){

    var countryLos = localStorage.getItem('countryV');
    if(countryLos){
        var crowdfund = $(".crowdfunding-section.pdp-core-form");
        var newsletterF = $(".email-signup-wrap.email-signup-swap");
        var emailsignupE = false;
        var pdpsoldout = false;
        var crowdfundE = false;
        var soldoutW = $(".sold-out-subscription.pdp-core-form");
        var html = '<div class="checkbox-con"><input type="checkbox" id="checkbox-terms" class="checkbox-termsC" /><label for="checkbox-terms"></label></div>';
        if(newsletterF.length > 0){
            emailsignupE = true
        }
        if(soldoutW.length > 0){
            pdpsoldout = true;
        }
      if(crowdfund.length > 0){
        crowdfundE = true
      }
        if(countryLos == 'US'){
            if(emailsignupE == true){
                if(screen.width > 1023){
                    newsletterF.find('.news-paragraph.desktop-show .checkbox-con').remove()
                }
                else{
                    newsletterF.find('.news-paragraph.mobile-show .checkbox-con').remove()
                }
            }
            if(pdpsoldout == true){
                soldoutW.find('.sold-out-disc-text checkbox-con').remove()
            }
          if(crowdfundE == true){
            crowdfund.find('.sold-out-disc-text checkbox-con').remove()
          }
            $(".newsletter-modal-wrap.form .logo-container li input[type='checkbox']").prop('checked', true);
            $(".newsletter-modal-wrap.form .legal-content input[type='checkbox']").prop('checked', true);
            $(".membership-signup-bottom .checkbox-container input[type='checkbox']").prop('checked', true);

        }
        else{
            if(emailsignupE == true){
                if(screen.width > 1023){
                    newsletterF.find('.news-paragraph.desktop-show').prepend(html)
                }
                else{
                    newsletterF.find('.news-paragraph.mobile-show').prepend(html)
                }
            }
            if(pdpsoldout == true){
                var html = '<div class="checkbox-con"><input type="checkbox" id="checkbox-terms0" class="checkbox-termsC" /><label for="checkbox-terms0"></label></div>';
                soldoutW.find('.sold-out-disc-text').prepend(html);
            }
          if(crowdfundE == true){
                var html = '<div class="checkbox-con"><input type="checkbox" id="checkbox-terms0" class="checkbox-termsC" /><label for="checkbox-terms0"></label></div>';
                crowdfund.find('.sold-out-disc-text').prepend(html);
            }
        }
    }
    else{
        fetch("https://content-svcs.mattel.com/geoservice").then(function(response) {
        return response.json();
        }).then(function(data) {
            var cntry = data.country;
            localStorage.setItem('countryV', cntry)
            if(cntry == 'US'){
                $(".newsletter-modal-wrap.form .logo-container li input[type='checkbox']").prop('checked', true);
                $(".newsletter-modal-wrap.form .legal-content input[type='checkbox']").prop('checked', true);
                $(".membership-signup-bottom .checkbox-container input[type='checkbox']").prop('checked', true);
            }
        })
    }

}


function mobileColorC(){
    if(window.innerWidth < 1024){
        $(".changC-mobile").each(function(){
            var cThis = $(this);
            var mBorder = cThis.attr('m-borderC');
            var mText = cThis.attr('m-textC');
            var mbg = cThis.attr('m-bgC');
            if(mBorder){
                if(mBorder !=''){
                    cThis.css("border-color", mBorder);
                }

            }
            if(mText){
                if(mText !=''){
                    cThis.css("color", mText);
                    cThis.find(".timer-content .h2, .h2.separator").css("color", mText);
                }

            }
             if(mbg){
                if(mbg !=''){
                    cThis.css("background-color", mbg);
                }

             }
         });
    }

}


function jointhecovoslider(){
    var wrap = $(".join-convo-wrap");
    var sliderDiv = wrap.find('.convo-item-wrap');
    if(window.screen.width < 1024){
        var findLi = setInterval(function(){
            if(sliderDiv.find('li').length > 0){
                clearInterval(findLi);

                sliderDiv.find('ul').slick({
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: false,
                    centerMode: true,
                    responsive: [
                        {
                          breakpoint: 1023,
                          settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                            infinite: true,
                          }
                        },
                        {
                          breakpoint: 600,
                          settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                          }
                        },
                        {
                          breakpoint: 481,
                          settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            centerPadding: '139px',
                          }
                        },
                        {
                            breakpoint: 376,
                            settings: {
                              slidesToShow: 1,
                              slidesToScroll: 1,
                              centerPadding: '105px',
                            }
                          },
                        {
                            breakpoint: 361,
                            settings: {
                              slidesToShow: 1,
                              slidesToScroll: 1,
                              centerPadding: '88px',
                            }
                          },
                          {
                            breakpoint: 321,
                            settings: {
                              slidesToShow: 1,
                              slidesToScroll: 1,
                              centerPadding: '48px',
                            }
                          }
                      ]
                });
            }
         }, 3000);

    }
}

function splitModuleJs() {
  var cardW = $(".card_split_wrap");
  if(cardW.length>0){
    var loaderW = cardW.find('.split-module');
    if(cardW.length>0 && cardW.find('video').length>0){
      var cardImageHeight = cardW.find('.card_image img').height();
      var style = {
        'height': cardImageHeight+'px'
      }
      cardW.find('.card_box .card_image').css(style);
      cardW.find('.card_body.slider-card').slick({
        slidesToShow: 4,
        infinite: true,
        arrows: true,
        nextArrow: '<button class="next-btn">&nbsp;</button>',
        prevArrow: '<button class="left-btn">&nbsp;</button>'
      });
    }
    loaderW.removeClass('showloader');
    cardW.find('.card_body').removeClass('hideContent');
    var cardBody =  cardW.find('.card_body');
    if(window.screen.width<780){
      cardBody.each(function async() {
        var thisE = $(this);
        if(thisE.find('.card_box_wrap').hasClass('top_of_image')){
          thisE.find('.card_box_wrap').removeClass('top_of_image');
        }
        if(thisE.hasClass('slider-card')){
          thisE.slick('unslick');
        }
        if(thisE.hasClass('show_slider_mobile')){
          thisE.slick({
            slidesToShow: 1,
            infinite: false,
            arrows: false,
            nextArrow: '<button class="next-btn">&nbsp;</button>',
            prevArrow: '<button class="left-btn">&nbsp;</button>',
            centerMode: true,
            centerPadding:'54px',
          });
        }
      })
    }
  }

}
function arrayMax(arr) {
    return arr.reduce(function (p, v) {
      return ( p > v ? p : v );
    });
}
$(document).ready(function(){
    imagecarousel();
    flexSlider();
    mobileColorC();
    jointhecovoslider();
    coundtryCheck();
    if($('.image-container-zoom').length){
      if(window.screen.width > 767){
        $('.image-container-zoom').zoom();
      }
    }
    anchorNamescroll();
    dropdownValue();
    // preorderDateShow();
    // preorderTextShow();
    splitModuleJs();
});

$(window).on('load', function(){
    var wrap = $(".image-carousel-wrap .slider-image-carousel");
    slickFindColor(wrap);
    challengePageNews();
});

function openmodal(data){
    data.find('.newsletter-modal-wrap.form').removeClass('hide');
}
function closemodal(data){
    data.find('.newsletter-modal-wrap.form').addClass('hide');
}
$(document).on('click', '.newsletter-modal-wrap.form .signupbtn-wrap .dontwnat', function(e){
    e.preventDefault();
    var thisE = $(this);
    var parentDF = thisE.parents('.newsletter-modal-wrap').parent();
    closemodal(parentDF);

})
$(document).on('click', '.newsletter-modal-wrap .signupbtn-wrap .btn-close,.newsletter-modal-wrap .thank-close', function(e){
    e.preventDefault();
    var cUrl = location.href;
    var targetId = sessionStorage.getItem('targetId');
    sessionStorage.setItem("newsletterSectionId", '');
    sessionStorage.setItem("targetId", '');
    var newU = cUrl.replace('customer_posted=true', '');
    newU = newU.replace('#contact_form', '');
    location.href = newU+'?#'+targetId;

    // reloads window to close sold out modal
    if (newU.includes('#soldout-pdp')) {
      location.reload();
    }
});
$(document).on('click', '.js-membership-modal-close', function(e){
  $('#membershipModal').addClass('hide');
});
$(document).on('click', '.js-membership-modal-btn', function(e){
  $('#membershipModal').removeClass('hide');
});
$(document).on('click', '.membership-modal', function(e){
  if (e.target.classList.contains('membership-modal')) {
    $('#membershipModal').addClass('hide');
  }
});
$(document).on('click', '.crowdfund-signup', function(e){
    e.preventDefault();
    var thisE = $(this);
    var parentS = thisE.parents(".crowdfunding-section.pdp-core-form");
    var targetId = parentS.attr('id');
    var emailInput = $('#crowdFundemail').val();
    var emailRegex=/^([a-zA-Z]+[a-zA-Z0-9_\-\+\.]+)@((([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    var crowdsubmit = false;
    var cowndfundp = thisE.parents(".crowdfunding-section");
    var cowndfundpCM = cowndfundp.find('.checkbox-con');
    var termsCM = parentS.find('.checkbox-con');
    if(termsCM.length>0){
        if(parentS.find('.checkbox-con input[type="checkbox"]').prop('checked') == true){
            crowdsubmit = true
        }
        else{
            crowdsubmit = false
        }
    }
    else{
        crowdsubmit = true;
    }
    if(crowdsubmit == true){
        if(emailInput==""){

            $(".signupError").html('The email address field cannot be empty!');
            $(".signupError").addClass('showE');
            setTimeout(function(){
                $(".signupError").removeClass('showE');
            },4000)
                // $("#signupError").addClass('active').stop().delay(500).queue('',function(){
                //     $(this).removeClass('active');
                // });
                //$("#signupError").html($(this).data('empty'))
        }
        else if(!emailRegex.test(emailInput)){
          $(".signupError").html('The email entered is not in a valid format!');
            $(".signupError").addClass('showE')
            // $("#signupError").addClass('active').stop().delay(500).queue('',function(){
            //     $(this).removeClass('active');
            // });
            setTimeout(function(){
                $(".signupError").removeClass('showE');
            },4000)
                //$("#signupError").html($(this).data('error'))
        }else{
          var parentPDPsold= thisE.parents('.crowdfunding-section');
          var source = parentPDPsold.attr('data-src');
          var makeT = 'email_mc_'+source;
          var ftags = 'prospect,newsletter,'+makeT;

            sessionStorage.setItem("targetId",targetId);
            if(parentPDPsold.hasClass('pdp-core-form')){
              parentPDPsold.find('.newsletter-core-form input[name="contact[tags]"]').val(ftags);
              parentPDPsold.find('.newsletter-core-form input[name="contact[email]"]').val(emailInput);
              var newsletterSectionId = $('.newsletter-modal-wrap.thankyou').attr('id');
              sessionStorage.setItem("newsletterSectionId", newsletterSectionId);
              parentPDPsold.find('.newsletter-core-form form').submit();
            }
            else{
              thisE.parents('.crowdfunding-section').find(".news-email input").val(emailInput);
              thisE.parents('.crowdfunding-section').find('.newsletter-modal-wrap.form').removeClass('hide');
              newsletterLogoshowLimit(thisE.parents('.crowdfunding-section'));
            }

        }
    }
    else{
        parentS.find('.checkbox-con label').addClass('error');
        setTimeout( function(){
            parentS.find('.checkbox-con label').removeClass('error');
        } ,1800);
    }

})

$(document).on('click', '.template-product .sold-out-subscription .sold-out-news', function(e){
    e.preventDefault();
    var thisE = $(this);
    var parentS = thisE.parents(".sold-out-subscription.pdp-core-form");
    var targetId = parentS.attr('id');
    var emailInput = $('#emailAddress').val();
    var emailRegex=/^([a-zA-Z]+[a-zA-Z0-9_\-\+\.]+)@((([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    var soldsubmit = false;
    var crowdsubmit = false;
    var cowndfundp = thisE.parents(".crowdfunding-section");
    var cowndfundpCM = cowndfundp.find('.checkbox-con');
    var termsCM = parentS.find('.checkbox-con');
    if(termsCM.length>0){
        if(parentS.find('.checkbox-con input[type="checkbox"]').prop('checked') == true){
            soldsubmit = true
        }
        else{
            soldsubmit = false
        }
    }
    else{
        soldsubmit = true;
    }

    if(cowndfundpCM.length>0){
        if(cowndfundp.find('.checkbox-con input[type="checkbox"]').prop('checked') == true){
            crowdsubmit = true
        }
        else{
            crowdsubmit = false
        }
    }
    else{
        crowdsubmit = true;
    }

    if(soldsubmit == false || crowdsubmit == false){
      parentS.find('.checkbox-con label').addClass('error');
      parentS.find('.sold-out-disc-error').addClass('show');
      setTimeout( function(){
          parentS.find('.checkbox-con label').removeClass('error');
          parentS.find('.sold-out-disc-error').removeClass('show');
      } ,4000);

      if(emailInput==""){
        $("#signupError").addClass('showE');
        gtagformError_pdpsoldout("Email Address","The email address field cannot be empty!");
        setTimeout(function(){
            $("#signupError").removeClass('showE');
        },4000)
      } else if(!emailRegex.test(emailInput)){
        $("#signupError").addClass('showE');
        gtagformError_pdpsoldout("Email Address","The email entered is not in a valid format!");
        setTimeout(function(){
            $("#signupError").removeClass('showE');
        },4000)
      }
    }
    else{
        if(emailInput==""){
            $("#signupError").addClass('showE');
            gtagformError_pdpsoldout("Email Address","The email address field cannot be empty!");
            setTimeout(function(){
                $("#signupError").removeClass('showE');
            },4000)
                // $("#signupError").addClass('active').stop().delay(500).queue('',function(){
                //     $(this).removeClass('active');
                // });
                //$("#signupError").html($(this).data('empty'))
        }
        else if(!emailRegex.test(emailInput)){
            $("#signupError").addClass('showE');
            gtagformError_pdpsoldout("Email Address","The email entered is not in a valid format!");
            // $("#signupError").addClass('active').stop().delay(500).queue('',function(){
            //     $(this).removeClass('active');
            // });
            setTimeout(function(){
                $("#signupError").removeClass('showE');
            },4000)
                //$("#signupError").html($(this).data('error'))
        }else{
          var parentPDPsold= thisE.parents('.pdp-soldout');
          if(parentPDPsold<0){
            parentPDPsold= thisE.parents('.crowdfunding-section');
          }
          var source = parentPDPsold.attr('datasrc');
          var makeT = 'email_mc_'+source;
          var ftags = 'prospect,newsletter,'+makeT;
          gtagformSubmit_pdpsoldout("content_area","PDP soldout Emailsignup");
            sessionStorage.setItem("targetId",targetId);
            if(parentPDPsold.hasClass('pdp-core-form')){
              parentPDPsold.find('.newsletter-core-form input[name="contact[tags]"]').val(ftags);
              parentPDPsold.find('.newsletter-core-form input[name="contact[email]"]').val(emailInput);
              var newsletterSectionId = $('.newsletter-modal-wrap.thankyou').attr('id');
              sessionStorage.setItem("newsletterSectionId", newsletterSectionId);
              parentPDPsold.find('.newsletter-core-form form').submit();
            }
            else{
              $("#prefilledEmail").val(emailInput);
              thisE.parents('.sold-out-subscription').find('.newsletter-modal-wrap.form').removeClass('hide');
              newsletterLogoshowLimit(thisE.parents('.sold-out-subscription'));
            }

        }
    }

})
$(document).on('click', '.newsletter-modal-wrap .signupbtn-wrap .btn-signup', function(e){

    e.preventDefault();


    var thisE = $(this);
    var ddParent = thisE.parents(".newsletter-modal-wrap").parent();
    var latE = ddParent.find("#prefilledEmail").val();
    var latEvali = emailvalidation(latE);
    var parents = thisE.parents('.modal-content');
    var legC = parents.find('#legatC');
    var favPrefix = parents.find('.logo-container').attr('data-fav');
    var srcD = thisE.attr('data-src');
    var lateEmerror = thisE.parents('.modal-content').find('.pre-email-error');
    var errorMsg = lateEmerror.attr('data-value');
    var errorHtml = "<p class='error-text'>"+errorMsg+"</p>";

    if(legC.prop('checked') == true){
        if($("#prodSku")[0]){
            var prodSKUPDP = $("#prodSku").val();
        }
        if(favPrefix ==''){
            favPrefix == 'Fav-Brand'
        }
        var brand = [];

        parents.find('.logo-container .brand-logo-li').each(function(){
            var cThis = $(this);
            if(cThis.hasClass('hide')){}
            else{
                if(cThis.find('.brand-name').prop("checked") == true){
                    var bVal = cThis.find('.brand-name').val();
                    if(favPrefix == 'email_pref_src'){
                        bVal = 'email_'+bVal+'_'+srcD;
                        brand.push(bVal);
                    }
                    else{
                        bVal = favPrefix+bVal;
                        brand.push(bVal);
                    }

                }
            }
        });

        if(latE !='' && latEvali == true){
            if(brand.length >= 0){
                if(brand.length == 0){
                    var newsV = 'newsletter,email_mc_'+srcD+'';
                }
                else{
                    var aS = brand.toString();
                    var newsV = 'newsletter,email_mc_'+srcD+','+aS;
                }

                if(prodSKUPDP && prodSKUPDP!=""){
                    newsV = newsV+",following_"+prodSKUPDP;
                }

                if ($(".crowdfunding-waiting")[0]){
                    var brandCde = $("#brandCode").val();
                   newsV = newsV+",email_"+brandCde+"_crowdfunding";
                }

                ddParent.find(".newsletter-core-form .newsletterFields").val(newsV);
                ddParent.find(".newsletter-core-form .newsletterEmail").val(latE);
                ddParent.find(".newsletter-core-form form").submit();

            }
            else{
                if(prodSKUPDP && prodSKUPDP!=""){
                    var skuTag = "following_"+prodSKUPDP;
                    ddParent.find("#newsletterFields").val(skuTag);
                }
                ddParent.find(".newsletter-core-form form").submit();
            }
            var sectionid = parents.find('.logo-container').attr('data-tyd');
            sessionStorage.setItem("newsletterSectionId", sectionid);
        }
        else{
            lateEmerror.html(errorHtml);
            setTimeout(function(){
                lateEmerror.html('');
            },2000);
        }
    }
    else{
        parents.find('label[for="legatC"]').addClass('error');
        if(parents.find('.legalcheck').hasClass('error-text')){}
        else{
            parents.find('.legalcheck').addClass('error-text');
            parents.find('.legalcheck').append('<div class="error">You must opt-in if you want to start receiving email communications.</div>')
        }

    }



});


$(document).on('change','#legatC', function(){
    var parentD = $(this).parents(".newsletter-modal-wrap");
    parentD.find('label[for="legatC"]').removeClass('error');
    parentD.find('.legalcheck').html('');
    parentD.find('.legalcheck').removeClass('error-text');
})




$(document).on('click', '.newsletter-modal-wrap.form .logo-container li', function(){
    var thisE = $(this);
    var checkF = thisE.find('.brand-content');
    checkboxActive(checkF);
})


$(document).on('click','.mini-cart-container .remove-items-mini', function(e){
    e.preventDefault();
    var cthis = $(this);
    var parentM = cthis.parents('.mini-cart-container');
    var loadD = parentM.find('.mini-cart');
    loadD.addClass('loaderShow');
    loadD.find('.minicart-loader').append('<div class="loaderCart"></div>')
    var dataKey = cthis.attr('data-key');
    var gwpCheck = cthis.attr('data-gwp-check');
    gtagRemovecart(cthis);
    removeItem(dataKey,loadD,gwpCheck);
})
function gtagRemovecart(curritem){
  var parent=curritem.parents('.mini-cart__item-wrapper');
  var item_title = parent.find('.mini-cart-item__title a').text();
  var gtm_chars = SDG.Data.gtm_chars.split(',') || [];
  var product_title = __.removeChars(item_title, gtm_chars);
  var hasCrossSellValue = parent.find('#crossSellProductSku').val();
  var crossSellProduct = hasCrossSellValue ? true : false;
  var crossSellProductSku = hasCrossSellValue ? parent.find('#crossSellProductSku').val() : '';
  var $couponTextInput = parent.find('#miniCartCouponText').val();
  var item = {
    'age_group': parent.find('#ageGrade').val() || '',
    'cross_sell_product': crossSellProduct || '',
    'cross_sell_product_sku': crossSellProductSku || '',
    'item_id': parent.find('#prodSku').val(),
    'item_sku': parent.find('#prodSku').val(),
    'item_name': product_title,
    'item_brand': parent.find('.mini-cart-item__vendor').text(),
    'item_badge': parent.find('#badge').val() || '',
    'item_category': parent.find('#productCategory').val(),
    'item_category2': parent.find('#productCategory2').val(),
    'merch_vendor': parent.find('#productVendor').val(),
    'product_availability': $('#product-availability').val(),
    'price': parent.find('#product-price').val(),
    'discount': parent.find('#discount-amount').val(),
    'original_price': parent.find('#original-price').val(),
    'item_bundle': 'false',
    'item_bundle_sku': '',
    'item_variant': parent.find('#variantId').val(),
    'item_size': parent.find('#itemSize').val() || '',
    'item_color': parent.find('#itemColor').val() || '',
    'quantity': parent.find('#product-quantity').val(),
    'upgrade_option': parent.find('#upgradeOption').val() || '',
    'item_promo': $couponTextInput !== '' ? 'true' : 'false',
    'coupon': $couponTextInput !== '' ? $couponTextInput : '',
  };
  window.dataLayer.push({
    'event': 'remove_from_cart',
    'ecommerce': {
      'currency': Shopify.currency.active,
      'items': [item]
    }
 })
}

function removeItem(data,loadD,gwpCheck){
  var data = {
    quantity: 0,
    id: data
  }

  jQuery.ajax({
    type: 'post',
    url: '/cart/change.js',
    data: data,
    success: function(d){
        $.getJSON('/cart', function(cart){
            $(document).trigger('theme:cart:updated', [cart, false, false]);
            loadD.removeClass('loaderShow');
            loadD.find('.minicart-loader').html('');

            if (gwpCheck && SDG.removeGwp) SDG.removeGwp(window.location.href);
            else location.reload();
        })
    },
    dataType: 'json'
  });
}



function flexSlider(){
    var wrap = $(".flex-grid-wrapper");
    var sliderDiv = wrap.find('.flex-mobile-slider ul');

    if (!sliderDiv || typeof sliderDiv.slick !== 'function') return;

    sliderDiv.slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        centerMode: true,
    }).on('beforeChange', function(event,slick,currentSlide, nextSlide){
        var ths = $(this);
        var slength= ths.find('li').length;
        slength = slength-1;
        if(slength == nextSlide){
            ths.find('.slick-list.draggable').addClass('full-width');
        }
        else{
            ths.find('.slick-list.draggable').removeClass('full-width');
        }
    })
}
function emailsignupactive(){
    var newsletterWrap = $(".email-signup-wrap");
    if(newsletterWrap.length>0){
        var newsCheckbox = newsletterWrap.find('.checkbox-con .checkbox-termsC');
        if(newsCheckbox.length>0){

            for(var i=0;i<newsCheckbox.length; i++){
                newsletterWrap.each(function(index){
                    if(index == i){
                        var indexC = i+1;
                        var id = $(this).find('.checkbox-termsC').attr('id');
                        var newId = id+indexC;
                        $(this).find('.checkbox-termsC').attr('id', newId);
                        $(this).find('.checkbox-con label').attr('for', newId)
                    }
                })

            }
        }
    }
}
$(document).ready(function()
{
    emailsignupactive();
    var sectionIDK = sessionStorage.getItem("newsletterSectionId");
    var currentUrl = location.href;
    if ((sectionIDK == "" || sectionIDK == undefined || sectionIDK == null) && (currentUrl.indexOf('?customer_posted=true') > 0 || currentUrl.indexOf('form_type=customer') > 0)) {
        if ($("#pageIndentify").val() == "page") {
            addToCartTemplate();
        }
    }
    $('body').on('click', '.submit-add-to-cart', function (e) {
        e.preventDefault();
        let emailaddress = $(this).closest('.membership-signup-bottom').find('#emailAddress').val();
        $(this).parents('.join-content').find('signupError').text("");
        if (emailvalidation(emailaddress) && $("#accept-terms-conditions-last").is(":checked")) {
            $(this).parents('.join-content').find('.newsletter-core-form #emailAddress1').val(emailaddress);
            $(this).parents('.join-content').find('.newsletter-core-form form').submit();
        } else if (emailaddress != "" && $("#accept-terms-conditions-last").is(":checked") && $(this).hasClass('hero-banner-add-to-cart') != true) {
            $(this).parents('.join-content').find('.signupError').text($(this).attr('data-error'));
            return false;
        }
        else {
            addToCartTemplate();
        }
    })
});

function searchProductCart(varientID,cartItem){
    for (var i=0; i < cartItem.length; i++) {
        if (cartItem[i].variant_id == varientID) {
            return 1;
        }
    }
}

function addToCartTemplate() {
  const { locale } = SDG.Data;
  const localePrefix = locale && locale !== '/' ? `/${locale}` : '';
  const gtmDataLayer = {

    /**
     * Track Bag event
     */
    bagEvent: async (obj, event) => {
      if (!obj) return;

      const items = [];
      await obj.items.reduce(async (prev, item) => {
        await prev;
        const { metaPayload, handle } = item;

        // Fetch additional product data if needed
        if (!metaPayload) {
          return new Promise((resolve) => {
            fetch(`${localePrefix}/products/${handle}?view=json`)
              .then((resp) => resp.json())
              .then((json) => {
                const newItem = { ...item, ...json.product || {} };
                const itemObj = gtmDataLayer.bagItem(newItem);
                items.push(itemObj);
                resolve();
              })
              .catch((error) => {
                console.error({ error });
                const itemObj = gtmDataLayer.bagItem(item);
                items.push(itemObj);
                resolve();
              });
          });
        }

        const itemObj = gtmDataLayer.bagItem(item);
        items.push(itemObj);
        return Promise.resolve();
      }, Promise.resolve());

      // eslint-disable-next-line
      dataLayer.push({
        event,
        cart_id: obj.cart_token || '',
        ecommerce: {
          currency: SDG.Data.currencyCode,
          items,
        },
      });
    },

    /**
     * Bag Item
     */
    bagItem: (product = {}) => {
      const tags = product?.productJson?.tags || [];
      const categoryArray = tags.filter((tag) => tag.includes('Category'));
      const {
        _upgrade_option: upgradeOption,
        _cross_sell_product_sku: crossSellProductSku,
        _item_bundle_id: itemBundleIdProp,
      } = product.properties;
      let addToCartType = 'standard';
      if (product?.metafields?.badge === 'Pre-order') {
        addToCartType = 'pre-order';
      }
      if (tags && tags.includes('merch_vendor: Customily')) {
        addToCartType = 'Personalize';
      }
      let evergreenType = 'no';
      if (tags && (tags.includes('Type: Evergreen') || tags.includes('Drops'))) {
        evergreenType = 'yes';
      }

      let itemBundleId = itemBundleIdProp;
      if (!itemBundleId && tags && tags.includes('Bundled')) {
        const firstVariant = product.productJson?.varaints[0];
        itemBundleId = firstVariant.sku;
      }

      return {
        index: 1,
        add_to_cart_type: addToCartType,
        age_group: product?.metafields?.age_grade || '',
        item_id: product.sku.split('_')[0],
        item_sku: product.sku,
        item_badge: product?.metafields?.badge || '',
        item_name: product.title,
        item_brand: product.vendor,
        item_category: categoryArray[0] || '',
        item_category2: categoryArray[1] || '',
        merch_vendor: product.vendor,
        evergreen: evergreenType,
        product_availability: 'available',
        price: product.price,
        discount: product.line_level_total_discount,
        original_price: product.original_price,
        item_bundle: 'false',
        item_bundle_sku: '',
        item_variant: product.id,
        item_size: product.grams,
        quantity: product.quantity, // eslint-disable-next-line
        cross_sell_product: crossSellProductSku ? true : false,
        cross_sell_product_sku: crossSellProductSku || '',
        upgrade_option: upgradeOption || '',
        item_bundle_id: itemBundleId || '',
      };
    },
  };

    let productvarientID = $("#prod_to_add").val() != "" ? $("#prod_to_add").val() : 0;
    let isMembership = $("#isMembership").val() == "true" ? true: false;
    var statusLineItemValue = $('#variant_inventorystatus').val();
    var isRestrictedProduct = $('#isRestrictedProduct').val();
    var productHandle = $('#productHandle').val();
    var receiptIdLineItemValue = $('#item_atp_receipt_id').val();
    var backorderdateLineItemValue = $('#variant_backorderdate').val();
    let dataObj = {};
    dataObj.quantity = 1;
    dataObj.id = productvarientID;
    let property = {};
    if(statusLineItemValue != undefined && statusLineItemValue != '') {
        property._variant_inventorystatus = statusLineItemValue;
    }
    if(receiptIdLineItemValue != undefined && receiptIdLineItemValue != '') {
        property._item_atp_receipt_id = receiptIdLineItemValue;
    }
    if(backorderdateLineItemValue != undefined && backorderdateLineItemValue != '') {
        property._variant_backorderdate = backorderdateLineItemValue;
    }
    if(isMembership) {
        property._membership_no_agreement = true;
    }
    dataObj.properties = property;

    const { rlcAccessBannerSellingPlan = false } = SDG?.Data;
    if (rlcAccessBannerSellingPlan && productvarientID === rlcAccessBannerSellingPlan.productId) {
      dataObj.selling_plan = rlcAccessBannerSellingPlan.planId;
      delete dataObj.properties._membership_no_agreement;
    }

    const bagHasPreOrder = SDG.Data.bagItems
      .find((item) => item.selling_plan_allocation?.selling_plan || item.full_data.properties._restricted_cart);
    const { bagItems } = SDG.Data;
    if (isRestrictedProduct === 'true' && bagItems.length > 0 && !bagHasPreOrder) {
      const [sameItem] = bagItems.filter((item) => item.handle === productHandle.replace('/products/', ''));
      if (sameItem) {
        updateItemQty(sameItem);
      } else {
        SDG.Data.mixedCartModal.open('modalMixedCart');
      }
      return; // escape function
    } else if ((!isRestrictedProduct || isRestrictedProduct === 'false') && bagHasPreOrder) {
      SDG.Data.mixedCartModal.open('modalMixedCart');
      return;
    }

    if (productvarientID != "" && productvarientID != undefined) {
        const locale = SDG.Data?.locale !== '/' ? SDG.Data?.locale : '';
        fetch('/cart.js')
            .then(response => response.json())
            .then(data => {
                if(searchProductCart(productvarientID,data.items)){
                  gtmDataLayer.bagEvent(data, 'add_to_cart')
                  .then(() => {
                    window.location.href = `${locale}/cart`;
                  })
                }else{
                    $.ajax({
                        type: 'POST',
                        url: '/cart/add.js',
                        data: dataObj,
                        dataType: 'json',
                        success: function (data) {
                            gtmDataLayer.bagEvent(data, 'add_to_cart')
                              .then(() => {
                                window.location.href = `${locale}/cart`;
                              });
                        }
                    });
                }
            });
    }
}
$(document).on('click', '.social-container .s-logos ul li > a,.leaving-site-modal', function(e){
    e.preventDefault();
    var thisurl=$(this).attr('href');
    var modalContainer=$('.leaving-interstitial-container');
    modalContainer.removeClass('hide');
    modalContainer.find('.keep-going').attr('href',thisurl);
});
$(document).on('click', '.leaving-interstitial-container .keep-stay,.leaving-interstitial-container .close-interstitial', function(e){
    e.preventDefault();
    var modalContainer=$('.leaving-interstitial-container');
    modalContainer.addClass('hide');
});
$(document).on('click','.leaving-interstitial-container', function(e) {
    if (event.target.id == "leaving-interstitial") {
        $('.leaving-interstitial-container').addClass('hide');
    }
});
function anchorNamescroll() {
    $('.anchor-name-scroll a.button[href^="#"]').click(function(event) {
        var id = $(this).attr("href");
        var offset = $('#shopify-section-header').height();
        var target = $(id).offset().top - offset;
        $('html, body').animate({scrollTop:target}, 500);
        event.preventDefault();
    });
}
$(window).resize(function(){
    mobileColorC();
});
$(document).on('change', '.cs-mobile-menu', function () {
    var thisE = $(this);
    var sev = thisE.val();
    if (sev != '#') {
        location.href = sev;
    }
});




function checklimitToAdd(sendId, from) {
    sendId = parseInt(sendId);
    var minicartwrap = $(".mini-cart__items");
    var limitp = false;
    var limitBy = 0;
    if (from == 'product_page') {
        var qtyC = 0;
        var productC = 0;
    } else {
        var qtyC = 1;
        var productC = 1;
    }

    var disableB = false;
    minicartwrap.find('.mini-cart__item-wrapper').each(function() {
        var productLimitId = $(this).attr('product-id');
        productLimitId = parseInt(productLimitId);
        if (productLimitId == sendId) {
            limitp = true;
            var productLimit = $(this).attr('product-limit');
            productLimit = parseInt(productLimit);
            limitBy = productLimit;
            qtyC = $(this).attr('product-qty');
            qtyC = parseInt(qtyC);
            productC = productC + 1;
        }
    })

    if (limitp == true) {

        if (qtyC == limitBy) {
            disableB = true
        } else if (productC == limitBy) {
            disableB = true
        } else {
            disableB = false;
        }
    } else {
        disableB = false;
    }

    var warningW = $(".warning-msg.limited").length;
    if(disableB == true && warningW == 0){
        var errorH = '<p class="warning-msg bold limited" style="display:block"><span class="warning-icon"> </span> You have reached the limit of '+limitBy+' per order.</p>';
        $(".product__add-to-cart").parents('#non-rlc-container').prepend(errorH);
    }
    return disableB;
}



$(document).on('click', '.collection-dropdown-filter .drop-btn', function(){
    var thisE = $(this);
    var parentE = thisE.parent();
    parentE.find('.dropdown-content ').toggleClass("hide");
})
$(document).on('click', function (e) {
    if ($(e.target).closest(".collection-dropdown-filter").length === 0) {
      var droC = $(".dropdown-content");
      if(!droC.hasClass('hide')){
        droC.toggleClass("hide");
      }
    }
});
